<template>
  <Container type="card-full" v-loading="loading">
    <div slot="header">
      <el-button type="primary" v-if="type === 1 || type === 2" @click="saveNotice" :loading="btnLoading" :disabled="isBtnDisabled || noticeAuditPending">保存</el-button>
      <el-button type="primary" v-if="+pjnotice.pjnoticetype === 2" @click="noticeSubmitDialog" :loading="btnLoading" :disabled="noticeAuditPending || noticeAuditStatus === 2">{{ +noticeAuditStatus === 0 ? '提交审核（如有需要）' : '提交审核' }}</el-button>
      <el-button type="primary" v-if="isShowBtn" @click="dialogVisible=true" :disabled="isBtnDisabled">采购报告提交审批</el-button>
    </div>
    <div class="main">
      <el-alert v-if="noticeAuditRejectDesc" type="error" :closable="false" show-icon
        :title="'审核不通过意见：' + noticeAuditRejectDesc"
        style="margin: 10px 0 15px 0; white-space: pre-wrap;"></el-alert>
      <el-alert v-if="noticeAuditStatus === 2" type="warning" :closable="false" show-icon
        title="该公告已审核通过；修改并保存后，原审核结果将作废，需重新提交审核"
        style="margin: 10px 0 15px 0;"></el-alert>
      <el-form ref="ruleForm" :model="pjnotice" label-position="right" class="mainfrom">
        <div class="row from_input">
          <el-form-item label="公告类型" prop="pjnoticetype" verify>
            <div v-if="type === 1">
              <el-select v-model="pjnotice.pjnoticetype" @change="pjnoticetypeChange" clearable placeholder="请选择">
                <el-option v-for="item in pjnoticetypeList" :key="item.value" :label="item.label"
                  :disabled="item.disabled" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div v-else class="from-value">
              {{ pjnotice.pjnoticetypedesc }}
            </div>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="同时发布到" verify v-if="+pjnotice.pjnoticetype === 6">
            <el-checkbox-group v-model="checkList">
              <el-checkbox v-for="i in picrList" :key="i.picid" :label="i.piccode">
                {{ i.picname }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <div class="content">
          <el-form-item label="公告主题" prop="pjnoticetitle" verify>
            <el-input v-model="pjnotice.pjnoticetitle" :maxlength="255" :disabled="isBtnDisabled" show-word-limit></el-input>
          </el-form-item>
        </div>
        <el-form-item label="公告附件">
          <div class="file">
            <div class="uploadbtn">
              <upload-btn @changed="setfile" text="上传附件" :disabled="isBtnDisabled"></upload-btn>
            </div>
            <div v-if="appendList.length" class="filelist">
              <div v-for="(item, index) in appendList" :key="index" class="fileitem">
                <div class="name" @click="downFile(item.appendurl)">
                  <a :src="uploadAddr + item.appendurl">{{
                      item.appendfilename
                  }}</a>
                </div>
                <div class="btn" @click="delappend(item)" v-if="!isBtnDisabled">
                  <span>删除</span>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item :label="noticeName" v-if="pjnotice.pjnoticetype == '6'">
          <div style="display: flex;flex-direction:row;width: 100%;">
            <div class="file">
              <div class="uploadbtn">
                <upload-btn @changed="setfile1" text="上传附件" :disabled="isBtnDisabled"></upload-btn>
                <div style="color: red">(用于报名的供应商下载)</div>
              </div>
              <div v-if="projectAppendList.length" class="filelist">
                <div v-for="(item, index) in projectAppendList" :key="index" class="fileitem">
                  <div class="name" @click="downFile(item.appendurl)">
                    <a :src="uploadAddr + item.appendurl">{{
                        item.appendfilename
                    }}</a>
                  </div>
                  <div class="btn" @click="delappend1(item)">
                    <span>删除</span>
                  </div>
                </div>
              </div>
            </div>
            <el-form-item label="公告中是否可见" style="margin-left: 5px;" v-if="pjnotice.pjnoticetype == '6'">
                      <div class="checkbox_w">
                        <el-checkbox v-model="projectpfvisibleVal"></el-checkbox>
                      </div>
            </el-form-item>
          </div>
        </el-form-item>
        <div class="row" v-show="+pjnotice.pjnoticetype === 6 || +pjnotice.pjnoticetype === 60 || +pjnotice.pjnoticetype === 3">
          <el-form-item label="选择模板">
            <div>
              <el-select v-model="pjnotice.tmplchoose" @change="setTmplContent" clearable placeholder="请选择">
                <el-option v-for="item in templateOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </div>
        
        <div class="content">
          <el-form-item label="公告内容">
            <div ref="editor" style="text-align: left"></div>
          </el-form-item>
        </div>
        <template v-if="this.pjnotice.pjnoticetype === '3' && (+this.project.projectstatus === 30 || +this.project.projectstatus === 20 || +this.project.projectstatus === 10)">
        <div style="color: #f91010; margin-left: 37px; margin-bottom: 5px;">{{ projectjjbgstatusDesc }}</div>
        <el-form-item label="报告附件">
          
          <div class="file">
            <div class="uploadbtn">
              <upload-btn @changed="setBgFile" text="上传附件" :disabled="isBtnDisabled"></upload-btn>
            </div>
            <div v-if="bgAppendList.length" class="filelist">
              <div v-for="(item, index) in bgAppendList" :key="index" class="fileitem">
                <div class="name" @click="downFile(item.appendurl)">
                  <a :src="uploadAddr + item.appendurl">{{
                      item.appendfilename
                  }}</a>
                </div>
                <div class="btn" @click="delBgAppend(item)" v-if="!isBtnDisabled">
                  <span>删除</span>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
        <div class="content">
          <el-form-item label="报告内容">
            <div ref="tjeditor" style="text-align: left"></div>
          </el-form-item>
        </div>
      </template>
      </el-form>
    </div>
    <el-dialog :close-on-click-modal="false" title="提交" :visible.sync="dialogVisible"
      width="720px" :modal-append-to-body="false">
      <div class="view-container">
          <div class="view-box">
            <div class="view-row">
              <div class="view-field">
                <div class="view-label">提交意见</div>
                <div style="width: 380px">
                  <el-input type="textarea" :autosize="{ minRows: 2 }" v-model.trim="checkdesc_submit" :maxlength="255"
                    show-word-limit></el-input>
                </div>
              </div>
            </div>
            <div class="view-row">
              <div class="view-field">
                <div class="view-label"></div>
                <div class="view-value">
                  <vxe-button type="primary" class="vxe-btn" @click="submit(status)" :loading="btnLoading">提交
                  </vxe-button>
                  <vxe-button type="primary" class="vxe-btn" @click="sendMsg(status)" :loading="btnLoading">提交并提醒采购人审核
                  </vxe-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提交审核" :visible.sync="noticeSubmitVisible"
      width="720px" :modal-append-to-body="false">
      <div class="view-container">
          <div class="view-box">
            <div class="view-row">
              <div class="view-field">
                <div class="view-label">提交意见</div>
                <div style="width: 380px">
                  <el-input type="textarea" :autosize="{ minRows: 2 }" v-model.trim="noticeSubmitdesc" :maxlength="255"
                    show-word-limit></el-input>
                </div>
              </div>
            </div>
            <div class="view-row">
              <div class="view-field">
                <div class="view-label"></div>
                <div class="view-value">
                  <vxe-button type="primary" class="vxe-btn" @click="noticeSubmitAudit" :loading="btnLoading">提交
                  </vxe-button>
                </div>
              </div>
            </div>
          </div>
        </div>
    </el-dialog>
  </Container>
</template>

<script>
import request from "@/utils/request";
import utils from "../../assets/js/utils";
import E from "wangeditor";
import config from "../../assets/config";
import uploadBtn from "../common/uploadBtn";
import common from "@/mixin/common";
import dayjs from "dayjs";
import moment from "moment";

export default {
  name: "pjnoticeForm",
  mixins: [common],
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() <= Date.now() - 86400000;
        },
      },
      templateOptions: [],
      list: [],
      picrList: [],
      project: {},
      pjnotice: {},
      pjnoticetypeList: [],
      appendList: [],
      projectAppendList: [],
      type: Number(this.$route.params.type),
      btnLoading: false,
      loading: false,
      editorContent: "",
      editor: "",
      tjeditor: {},
      checkList: [],
      dialogVisible: false,
      checkdesc_submit: '',
      btnLoading: false,
      bgAppendList: [],
      projectjjcontent: '',
      projectpfvisibleVal: false,
      psu_Bidding: [],
      // 变更公告提交审核（auditlogcode 30）
      noticeSubmitVisible: false,
      noticeSubmitdesc: '',
      noticeAuditPending: false,
      noticeAuditStatus: 0,
      noticeAuditRejectDesc: ''
    };
  },
  created() { },
  async activated() {
    await this.getProjectModel(1);
    if (this.$route.params.pjnoticeid) {
      await this.getModel();
      if (+this.pjnotice.pjnoticetype === 6) {
        await this.getTemplateOptions(1)
      }
      if (+this.pjnotice.pjnoticetype === 60) {
        await this.getTemplateOptions(5)
      }
      if (+this.pjnotice.pjnoticetype ===3) {
        await this.getTemplateOptions(8)
      }
    }
    await this.getPjnoticetypeList();
    await this.getList();
    await this.initEditor();
    await this.getPicrList();
    await this.getBgAppendList()
    await this.getNoticeAuditPending();
  },
  filters: {},
  components: { uploadBtn },
  computed: {
    projectjjbgstatusDesc () {
      if (this.pjnotice.pjnoticetype === '3') {
        if (this.project.projectjjbgstatus === '2') {
          return '采购失败报告审核中'
        } else if (this.project.projectjjbgstatus === '3') {
          return '采购失败报告已审核通过'
        } else if (this.project.projectjjbgstatus === '4'){
          return '采购失败报告已审核不通过,请修改后重新提交'
        }
          else {
          return '如需要编制失败报告，请填写以下内容，并使用提交审批'
        }
      }
    },
    isBtnDisabled () {
      if (this.pjnotice.pjnoticetype === '3' && this.project.projectjjbgstatus !== '1' && this.project.projectjjcontent && (+this.project.projectstatus === 20 || +this.project.projectstatus === 10)) {
        this.tjeditor.disable && this.tjeditor.disable()
        this.editor.disable && this.editor.disable()
        return true
      } else {
        return false
      }
    },
    isShowBtn () {
      return this.pjnotice.pjnoticetype === '3' && (+this.project.projectstatus === 20 || +this.project.projectstatus === 10)
    },
    uploadAddr() {
      return this.$store.getters.uploadAddr;
    },
    appendfromtype() {
      let appendfromtype = "";
      if (this.pjnotice.pjnoticetype == "1") {
        appendfromtype = "12";
      } else if (this.pjnotice.pjnoticetype == "2") {
        appendfromtype = "13";
      } else if (this.pjnotice.pjnoticetype == "3") {
        appendfromtype = "14";
      } else if (this.pjnotice.pjnoticetype == "4") {
        appendfromtype = "15";
      } else if (this.pjnotice.pjnoticetype == "5") {
        appendfromtype = "5";
      } else if (this.pjnotice.pjnoticetype == "6") {
        appendfromtype = "16";
      } else if (this.pjnotice.pjnoticetype == "60") {
        appendfromtype = "60";
      }
      return appendfromtype;
    },
    noticeName() {
      if (this.project.prsflg == "2") {
        return "招标文件";
      } else if (this.project.prsflg == "1" || this.project.prsflg == "3") {
        return "竞价文件";
      } else if (this.project.prsflg == "4" || this.project.prsflg == "5") {
        return "竞拍文件";
      } else if (this.project.prsflg == "6") {
        return "比选文件";
      }
    },
  },
  deactivated() {
    this.$destroy();
  },
  methods: {
    async getPusList () {
       let selectField = ` projectcode,projectquotationmode,projectlimitamt,projectpuserid,projectjjfile,prsflg,projectconfirmletter,projectcosid,projectid,projectname,projectdesc,prsbjendtime,projectjjbgstatus,projectjjcontent,prsbjtimes,prsbjbegtime,projectstatus`;
      let res = await request({
        method: "get",
        url: "/xmgl/tmpl/getTemplateProjectInfo",
        params: { projectid: this.$route.params.projectid, selectField },
      });
      this.psu_Bidding = res.data_psu
      res.data_psu = res.data_psu.map(item => {
        if (item) {
          item.pbrtime = dayjs(item.pbrtime).format('YYYY-MM-DD HH:mm:ss')
        }
        return item
      })
      this.project.psu_hasBidding = this.psu_Bidding.filter((e) => {
        return e.pbramt !== null
      })
      this.project.psu_hasBidding
      .sort((a, b) => {
        return a.psubidorder - b.psubidorder;
      })
      .forEach((e) => {
        e.pbtseq_UP = "第" + utils.upNumbers(e.pbtseq) + "轮";
        e.psubidorder_UP = utils.upNumbers(e.psubidorder);
        e.pbramt_UP =
          "￥" +
          utils.comdify(e.pbramt);
      });
      switch (+this.project.projectquotationmode) {
        case 1:
          this.project.bjname = '报价金额（元）'
          break;
        case 2:
           this.project.bjname  = '报价上浮率（%）'
          break;
        case 3:
           this.project.bjname = '报价下浮率（%）'
          break;
        case 4:
           this.project.bjname = '报价折扣率（%）'
          break;
      }
      this.project.psu_hasNotBidding = this.get_hasNoQuote(this.project.psu_hasBidding, res.data_pbt)
    },
    get_hasNoQuote(psu_hasBidding, pbtList) {
      // 获取最后一轮有报价的人
      let arr = psu_hasBidding.filter(e => {
        return +e.pbtseq === +this.project.prsbjtimes;
      });
      //去重
      return pbtList.filter(item1 => {
        return arr.every(item2 => {
          return +item2.psucomid !== +item1.pbrcomid
        })
      })
    },
    async getBgAppendList() {
      let res = await request({
        method: "get",
        url: "/ywgl/append/getAppendListByFromId",
        params: {
          appendfromid: this.$route.params.projectid,
          appendfromtype: 20,
        },
      });
      this.bgAppendList = res;
    },
    setBgFile (path, filename) {
      let append = {
        appendid: 0,
        appendfromid: 0,
        appendfromtype: 20,
        appendtype: "100",
        appendseq: this.bgAppendList.length + 1,
        appendfilecode: "",
        appendfilename: filename,
        appendurl: path.replace(this.uploadAddr, ""),
      };
      this.bgAppendList.push(append);
      console.log(this.bgAppendList)
    },
    delBgAppend(file) {
      this.$confirm(`确定移除 ${file.appendfilename}？`, "提示", {
        type: "warning",
      })
        .then(() => {
          let index = this.bgAppendList.findIndex(
            (val) => val.appendfilename === file.appendfilename
          );
          this.bgAppendList.splice(index, 1);
        })
        .catch(() => { });
    },
    async sendMsg() {
      this.$confirm(`是否确定发送短信`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {

        await this.submit()

        let data = await request({
          url: '/xtgl/user/getUser',
          method: 'get',
          params: {
            userid: this.project.projectpuserid
          }
        })

        if (data.length > 0) {
          //尚未完成
          await request({
            url: '/sms/send',
            method: 'get',
            params: {
              type: '5',
              tel: data[0].usercode,
              name: `${this.project.projectname.length > 35 ? this.project.projectname.substring(0, 32) + '...' : this.project.projectname }`
            }
          })

        }
      })
    },
    async submit () {
      if (!this.projectjjcontent) {
        this.$message.warning(`请输入报告内容`);
          return;
      }
      if (!this.editorContent) {
        this.$message.warning(`请输入公告内容`);
          return;
      }
      if (!this.checkdesc_submit) {
          this.$message.warning(`请输入提交意见`);
          return;
      }
      if  (!this.pjnotice.pjnoticetitle) {
        this.$message.warning(`请输入公告主题`);
          return;
      }
      await this.addOrEdit(false)
      let data = await request({
        url: "/xmgl/project/projectSubmitJjbg",
        method: "post",
        data: {
          projectid: this.project.projectid,
          userid: this.$store.getters.loginUser.userid,
          projectjjbgstatus: 2,
          projectsubmitdesc: this.checkdesc_submit,
          projectjjcontent: this.projectjjcontent,
          appendList: this.appendList,
          projectconfirmletter: "<p></p>",
          appendList: this.bgAppendList,
          // fromcode: 'pjnoticeForm'
        },
      });
      if (data.issuccess === 1) {
        this.$message.success(`失败公告提交审核成功！`);
        this.dialogVisible = false;
        this.close();
      } else {
        this.$message.error(`失败公告提交审核失败！`);
      }
    },
    // ===================== 变更公告提交审核（auditlogcode 30，auditlogtype 1）=====================
    // 待审核（auditstatus 1）的变更公告不允许修改；已驳回（3）时展示驳回意见
    async getNoticeAuditPending() {
      this.noticeAuditPending = false;
      this.noticeAuditStatus = 0;
      this.noticeAuditRejectDesc = "";
      if (!this.$route.params.pjnoticeid || +this.pjnotice.pjnoticetype !== 2) {
        return;
      }
      const res = await request({
        url: "/auditlog/getNoticeAuditStatus",
        method: "get",
        params: {
          auditlogcosid: this.$store.getters.loginUser.cosid,
          auditlogfromid: this.$route.params.pjnoticeid,
          auditlogcode: 30,
        },
      });
      if (res && res.data) {
        this.noticeAuditStatus = +res.data.auditstatus || 0;
        // 已驳回：取最新一次驳回（auditlogtype 2 + auditresult 2）的意见，展示在编辑页顶部
        if (this.noticeAuditStatus === 3 && res.data.list && res.data.list.length) {
          for (let i = 0; i < res.data.list.length; i++) {
            const item = res.data.list[i];
            if (+item.auditlogtype === 2 && +item.auditresult === 2) {
              this.noticeAuditRejectDesc = item.auditlogcontent || "";
              break;
            }
          }
        }
      }
      if (this.noticeAuditStatus === 1) {
        this.noticeAuditPending = true;
        this.$message.warning("该公告已提交审核，审核中不能修改！");
        this.editor && this.editor.disable && this.editor.disable();
        this.tjeditor && this.tjeditor.disable && this.tjeditor.disable();
      }
    },
    // 保存入口：已审核通过的公告先确认（保存会作废原审核结果），再走原保存逻辑
    async saveNotice() {
      if (+this.pjnotice.pjnoticetype === 2 && this.noticeAuditStatus === 2) {
        try {
          await this.$confirm(
            "该公告已审核通过，保存后原审核结果将作废、需重新提交审核，是否继续？",
            "提示",
            { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning" }
          );
        } catch (e) {
          return;
        }
      }
      await this.addOrEdit();
    },
    noticeSubmitDialog() {
      if (!this.pjnotice.pjnoticetitle) {
        this.$message.warning(`请输入公告主题`);
        return;
      }
      if (!this.editorContent) {
        this.$message.warning(`请输入公告内容`);
        return;
      }
      this.noticeSubmitdesc = "";
      this.noticeSubmitVisible = true;
    },
    async noticeSubmitAudit() {
      if (!this.noticeSubmitdesc) {
        this.$message.warning(`请输入提交意见`);
        return;
      }
      // 待审核/已通过的不能重复提交（已通过如需重审请先修改）；驳回/已作废可重新提交
      if (this.pjnotice.pjnoticeid) {
        const status = await request({
          url: "/auditlog/getNoticeAuditStatus",
          method: "get",
          params: {
            auditlogcosid: this.$store.getters.loginUser.cosid,
            auditlogfromid: this.pjnotice.pjnoticeid,
            auditlogcode: 30,
          },
        });
        const auditstatus = status && status.data ? +status.data.auditstatus : 0;
        if (auditstatus === 1) {
          this.$message.warning(`该公告已提交审核，请等待审核结果`);
          return;
        }
        if (auditstatus === 2) {
          this.$message.warning(`该公告已审核通过，无需再次提交`);
          return;
        }
      }
      this.btnLoading = true;
      // 先保存公告再提交审核（冗余组装与 addOrEdit 一致，不改原保存逻辑）
      this.pjnotice.pjnoticeprojectid = this.$route.params.projectid;
      this.pjnotice.pjnoticedesc = this.editorContent;
      this.pjnotice.appendfromtype = this.appendfromtype;
      this.pjnotice.appendtype = "100";
      this.pjnotice.appends = this.appendList;
      this.pjnotice.appendProject = this.projectAppendList;
      this.pjnotice.pjnoticestatus = 0;
      this.pjnotice.cosid = this.$store.getters.loginUser.cosid;
      this.pjnotice.picrList = this.checkList;
      this.pjnotice.projectpfvisible = +this.projectpfvisibleVal;
      const data = await request({
        url: "/xmgl/pjnotice/addOrEdit",
        method: "post",
        data: this.pjnotice,
      });
      if (!(data && data.issuccess === 1)) {
        this.btnLoading = false;
        this.$message.error(`保存公告失败！`);
        return;
      }
      if (data.data && data.data.pjnoticeid) {
        this.pjnotice.pjnoticeid = data.data.pjnoticeid;
      }
      if (!this.pjnotice.pjnoticeid) {
        this.btnLoading = false;
        this.$message.error(`保存公告失败！`);
        return;
      }
      const res = await request({
        url: "/auditlog/submitNoticeAudit",
        method: "post",
        data: {
          auditlogcosid: this.$store.getters.loginUser.cosid,
          auditlogfromid: this.pjnotice.pjnoticeid,
          auditloguserid: this.$store.getters.loginUser.userid,
          auditlogcontent: this.noticeSubmitdesc,
        },
      });
      this.btnLoading = false;
      if (res && res.issuccess === 1) {
        this.noticeSubmitVisible = false;
        this.$message.success(`变更公告提交审核成功！`);
        this.close();
      } else {
        this.$message.error((res && res.msg) || `变更公告提交审核失败！`);
      }
    },
    async getList() {
      this.loading = true;
      this.list = await request({
        url: "/xmgl/pjnotice/getNoticeList",
        method: "get",
        params: { projectid: this.$route.params.projectid },
      });
      if (this.list.length === 0) {
        this.pjnoticetypeList = this.pjnoticetypeList.map((v) => {
          v.disabled = true;
          if (+v.value === 6) {
            // 没有公告的时候，稚嫩该选择
            v.disabled = false;
          }

          return v;
        });
      }
      if (this.list.length) {
        // this.pjnoticetypeList = this.pjnoticetypeList.map(v =>  {
        //   v.disabled = false
        //   if (+v.value === 6) {
        //     // 禁选项目公告
        //     let index = this.list.findIndex(t => +t.pjnoticetype === 6)
        //     if (index > -1) {
        //       v.disabled = true
        //     }
        //   }
        //   if (+v.value === 5) {
        //     // 禁选预成交公示
        //     let index = this.list.findIndex(t => +t.pjnoticetype === 5)
        //     if (index > -1) {
        //       v.disabled = true
        //     }
        //   }
        //   if(+v.value === 60){
        //     let index = this.list.findIndex(t => +t.pjnoticetype === 60)
        //     if (index > -1) {
        //       v.disabled = true
        //     }
        //   }
        //   return v
        // })

        this.pjnoticetypeList = this.pjnoticetypeList.map((v) => {
          v.disabled = false;
          if (+v.value === 6) {
            // 禁选项目公告
            let index = this.list.findIndex((t) => +t.pjnoticetype === 6);
            if (index > -1) {
              v.disabled = true;
            }
          }
          if (+v.value === 3 || +v.value === 4) {
            //废标公告、终止公告只能存在一个
            // 禁选废标，终止
            let index = this.list.findIndex(
              (t) => +t.pjnoticetype === 3 || +t.pjnoticetype === 4
            );
            if (index > -1) {
              v.disabled = true;
            }
          }
          if (+v.value === 5) {
            // 禁选预成交公示
            let index;
            if (+this.list[0].projectjjreportflg === 1) {
              index = this.list.findIndex(
                (t) => +t.pjnoticetype === 5 || t.projectjjbgstatus != 3
              );
            } else {
              index = this.list.findIndex((t) => +t.pjnoticetype === 5);
            }
            if (index > -1) {
              v.disabled = true;
            }
          }
          if (+v.value === 60) {
            let index;
            if (+this.list[0].projectjjreportflg === 1) {
              index = this.list.findIndex(
                (t) => +t.pjnoticetype === 60 || t.projectjjbgstatus != 3
              );
            } else {
              index = this.list.findIndex((t) => +t.pjnoticetype === 60);
            }

            if (index > -1) {
              v.disabled = true;
            }
          }
          this.list.forEach((e) => {
            if (+e.pjnoticetype === 6 && +e.pjnoticestatus !== 1) {
              //项目没有发布的时候，不能不能建立其他公告
              v.disabled = true;
            }
            if (+e.pjnoticetype === 3 && +e.pjnoticestatus === 1) {
              //废标公告、终止公告后不能建如何公告
              v.disabled = true;
            }
            if (+e.pjnoticetype === 4 && +e.pjnoticestatus === 1) {
              //废标公告、终止公告后不能建如何公告
              v.disabled = true;
            }
          });
          return v;
        });
      }
      this.loading = false;
    },
    async getModel() {
      this.pjnotice = await request({
        url: "/xmgl/pjnotice/getPJNoticeListById",
        method: "get",
        params: {
          pjnoticeid: this.$route.params.pjnoticeid,
          cosid: this.$store.getters.loginUser.cosid,
        },
      });
      this.appendList = this.pjnotice.appendList;
      this.checkList = this.pjnotice.checkList;
      this.editorContent = this.pjnotice.pjnoticedesc;
    },
    async getProjectModel(type) {
      this.project = await request({
        method: "get",
        url: "/xmgl/project/findProjectById",
        params: { projectid: this.$route.params.projectid },
      });
      if (type === 1) {
        this.projectpfvisibleVal = Boolean(this.project.projectpfvisible)
        this.projectAppendList = this.project.appendList_zb;
      }
    },
    async setTmplContent() {
      if (!this.pjnotice.pjnoticetype) {
        this.$message.warning("请先选择公告类型！");
        this.pjnotice.tmplchoose = ""
        return;
      }
      if (+this.pjnotice.pjnoticetype === 6 || +this.pjnotice.pjnoticetype === 3) {
        this.project.prsbmendtime_CN = dayjs(this.project.prsbmendtime).format(
          "YYYY年MM月DD日HH时mm分"
        );
        this.project.prsbjbegtime_CN = dayjs(this.project.prsbjbegtime).format(
          "YYYY年MM月DD日HH时mm分"
        );

        this.project.aaddr =
          +this.$store.getters.loginUser.dptbranchfalg === 1
            ? this.$store.getters.loginUser.dptaddress
            : this.$store.getters.loginUser.comaddr;
        this.project.acomname =
          +this.$store.getters.loginUser.dptbranchfalg === 1
            ? this.$store.getters.loginUser.dptfullname
            : this.$store.getters.loginUser.comfullname;
        this.project.projectlimitamtFormat = utils.comdify(this.project.projectlimitamt)
        this.project.nowDate_CN = dayjs().format("YYYY年MM月DD日");
        if (!this.editorContent) {
          await this.getTmpl(+this.pjnotice.pjnoticetype === 6 ? 1 : 8, this.project.prsflg);
        } else {
          this.$confirm(
            `按模板生成公告，将覆盖现有的公告内容，是否继续？`,
            "提示",
            {
              confirmButtonText: "是",
              cancelButtonText: "否",
              type: "warning",
            }
          ).then(async () => {
            await this.getTmpl(+this.pjnotice.pjnoticetype === 6 ? 1 : 8, this.project.prsflg, this.project.prsflg);
          }).catch(() => {
            this.pjnotice.tmplchoose = ""
          });
        }
      }
      if (+this.pjnotice.pjnoticetype === 60) {
        let selectField = "psuconfirmfeeamt,psubidflg,psupricerate,psuamt";
        this.project.psubidList = await request({
          url: "/cwgl/psuproject/getbidList",
          method: "get",
          params: { selectField, projectid: this.project.projectid },
        });
        this.project.psucomfirmSum = 0;
        this.project.psubidList.forEach((e) => {
          e.psuamt_CN =
            utils.comdify(e.psuamt) +
            "(" +
            utils.smallToBig(e.psuamt) +
            ")";
          this.project.psucomfirmSum += Number(e.psuamt);
          return e;
        });
        this.project.aaddr =
          +this.$store.getters.loginUser.dptbranchfalg === 1
            ? this.$store.getters.loginUser.dptaddress
            : this.$store.getters.loginUser.comaddr;
        this.project.acomname =
          +this.$store.getters.loginUser.dptbranchfalg === 1
            ? this.$store.getters.loginUser.dptfullname
            : this.$store.getters.loginUser.comfullname;
        this.project.nowDate_CN = dayjs().format("YYYY年MM月DD日");
        this.project.psucomfirmSum_CN = utils.comdify(
          String(this.project.psucomfirmSum)
        );
        await this.getPusList()
        if (!this.editorContent) {
          await this.getTmpl(5, this.project.prsflg);
        } else {
          this.$confirm(
            `按模板生成公告，将覆盖现有的公告内容，是否继续？`,
            "提示",
            {
              confirmButtonText: "是",
              cancelButtonText: "否",
              type: "warning",
            }
          ).then(async () => {
            await this.getTmpl(5, this.project.prsflg);
          }).catch(() => {
            this.pjnotice.tmplchoose = ""
          })
        }
      }
    },
    async pjnoticetypeChange(val) {
      if (!val) return;
      let name = "";
      let model = this.pjnoticetypeList.find((v) => +v.value === +val);
      if (+model.syscodeseq !== 1) {
        name = model.label;

        if (+model.value === 60) {
          await this.getTemplateOptions(5)
        }
      } else {
        if (this.project.prsflg == "2") {
          name = "招标公告";
        } else if (this.project.prsflg == "1" || this.project.prsflg == "3") {
          name = "竞价公告";
        } else if (this.project.prsflg == "4" || this.project.prsflg == "5") {
          name = "竞拍公告";
        } else if (this.project.prsflg == "6") {
          name = "比选公告";
        }

        if (this.project.prsflg == '1') {
          await this.getTemplateOptions(1)
        }
      }
      if (model.value == '3') {
          await this.getTemplateOptions(8)
        }
      this.$set(
        this.pjnotice,
        "pjnoticetitle",
        this.project.projectname +
        "(项目编号：" +
        this.project.projectcode +
        ")" +
        "的" +
        name
      );
      // this.pjnotice.pjnoticetitle ='关于'+ this.project.projectname +'(项目编号：'+ this.project.projectcode + ')'+'的' + name
      let wmenuList = await request({
        url: "/ywgl/wmenu/getWmenuBy",
        method: "get",
        params: {},
      });
      let wmenudatawhere = "";
      if (this.pjnotice.pjnoticetype == "1") {
        wmenudatawhere = "60";
      } else if (this.pjnotice.pjnoticetype == "2") {
        wmenudatawhere = "70";
      } else if (this.pjnotice.pjnoticetype == "3") {
        wmenudatawhere = "90";
      } else if (this.pjnotice.pjnoticetype == "4") {
        wmenudatawhere = "80";
      } else if (this.pjnotice.pjnoticetype == "6") {
        await this.getPicrList();
      }

      let wmenu = wmenuList.find((v) => v.wmenudatawhere == wmenudatawhere);
      if (wmenu) {
        this.pjnotice.pjnoticewmenuid = wmenu.wmenuid;
      }
      if (val === '3') {
        this.initTjEditor()
      }
    },
    async getTemplateOptions(type) {
      this.templateOptions = await request({
        method: "get",
        url: "/xmgl/tmpl/getTemplateOptions",
        params: { tmplcosid: this.$store.getters.loginUser.cosid, tmpltype: type },
      });
    },
    async getTmpl(tmpltype, tmplprsflg) {
      let model = {};
      model.selectField = `tmplcontent`;
      model.tmplid = this.pjnotice.tmplchoose;
      model.cosid = this.project.projectcosid;
      let res = await request({
        url: "/xmgl/tmpl/getTemplate",
        method: "get",
        params: model,
      });
      if (!res) {
        this.$message.warning("没有该类型模板！");
      } else {
        let tm = res.tmplcontent;
        let compiled = _.template(tm || "");

        this.editorContent = compiled(this.project);
        console.log(this.project)
        this.editor.txt.html(compiled(this.project));
      }
    },
    async getPjnoticetypeList() {
      this.pjnoticetypeList = await request({
        url: "/kfgl/syscode/getSysCodeList",
        method: "get",
        params: { syscode: "pjnoticetype" },
      });
    },
    initTjEditor () {
      if (this.$refs.tjeditor) {
        this.tjeditor = this.$refs.tjeditor && new E(this.$refs.tjeditor)
        this.tjeditor.config.uploadFileName = "file"
        this.tjeditor.config.uploadImgServer = `${config.baseUrl}upload/upload`;
        this.tjeditor.config.onchange = (html) => {
          this.projectjjcontent = html;
        };
        this.tjeditor.config.zIndex = 1;
        this.tjeditor.config.colors = [
          '#000000', '#333333', '#666666', '#999999', '#cccccc',
          '#ff0000', '#ff6600', '#ffcc00', '#33ff00', '#ff0066', '#00ffff',
          '#0066ff', '#6600ff', '#ff00ff', '#00ff66',
          '#DC143C', '#00CED1', '#FFD700'
        ];
        this.tjeditor && this.tjeditor.create()
        this.tjeditor.txt.html(this.project.projectjjcontent);
      }
    },
    initEditor() {
      this.initTjEditor()
      if (this.editor) {
        this.editor.txt.html(this.pjnotice.pjnoticedesc);
        return;
      }
      this.editor = new E(this.$refs.editor);
      this.editor.config.onchange = (html) => {
        this.editorContent = html;
      };
      this.editor.config.uploadFileName = "file";
      this.editor.config.uploadImgServer = `${config.baseUrl}upload/upload`;
      this.editor.config.zIndex = 1;
      this.editor.config.colors = [
        '#000000', '#333333', '#666666', '#999999', '#cccccc',
        '#ff0000', '#ff6600', '#ffcc00', '#33ff00', '#00ff66', '#00ffff',
        '#0066ff', '#6600ff', '#ff00ff', '#ff0066',
        '#DC143C', '#00CED1', '#FFD700'
      ];
      this.editor.create();
      this.editor.txt.html(this.pjnotice.pjnoticedesc);
    },
    delappend(file) {
      this.$confirm(`确定移除 ${file.appendfilename}？`, "提示", {
        type: "warning",
      })
        .then(() => {
          let index = this.appendList.findIndex(
            (val) => val.appendfilename === file.appendfilename
          );
          this.appendList.splice(index, 1);
        })
        .catch(() => { });
    },
    delappend1(file) {
      this.$confirm(`确定移除 ${file.appendfilename}？`, "提示", {
        type: "warning",
      })
        .then(() => {
          let index = this.projectAppendList.findIndex(
            (val) => val.appendfilename === file.appendfilename
          );
          this.projectAppendList.splice(index, 1);
        })
        .catch(() => { });
    },
    async setfile(path, filename) {
      let append = {
        appendid: 0,
        appendfromid: 0,
        appendfromtype: this.appendfromtype,
        appendtype: "100",
        appendseq: this.appendList.length + 1,
        appendfilecode: "",
        appendfilename: filename,
        appendurl: path.replace(this.uploadAddr, ""),
      };
      this.appendList.push(append);
    },
    async setfile1(path, filename) {
      let append = {
        appendid: 0,
        appendfromid: 0,
        appendfromtype: "11",
        appendtype: "100",
        appendseq: this.appendList.length + 1,
        appendfilecode: "",
        appendfilename: filename,
        appendurl: path.replace(this.uploadAddr, ""),
      };
      this.projectAppendList.push(append);
    },
    async addOrEdit(isJump = true) {
      this.btnLoading = true;
      this.loading = true;
      await this.getProjectModel(2);
      
      if (+this.pjnotice.pjnoticetype === 1) {
        if (
          moment(new Date()).isAfter(this.project.prsbjbegtime) ||
          moment(new Date()).isAfter(null)
        ) {
          this.$message.warning("报价/开标已开始，不允许发布变更公告");
          this.btnLoading = false;
          this.loading = false;
          return;
        }
      }
      console.log(await this.submitForm("ruleForm"), '====')
      this.submitForm("ruleForm")
        .then(async () => {
          console.log(555)
          this.pjnotice.pjnoticeprojectid = this.$route.params.projectid;
          this.pjnotice.pjnoticedesc = this.editorContent;
          this.pjnotice.appendfromtype = this.appendfromtype;
          this.pjnotice.appendtype = "100";
          this.pjnotice.appends = this.appendList;
          this.pjnotice.appendProject = this.projectAppendList;
          this.pjnotice.pjnoticestatus = 0;
          this.pjnotice.cosid = this.$store.getters.loginUser.cosid;
          this.pjnotice.picrList = this.checkList;
          this.pjnotice.projectpfvisible = +this.projectpfvisibleVal
          let data = await request({
            url: "/xmgl/pjnotice/addOrEdit",
            method: "post",
            data: this.pjnotice,
          });
          if (data.issuccess === 1) {
              if (isJump) {
                this.close();
                this.$message.success("保存成功");
                // 已通过审核的变更公告保存后原审核结果作废，需重新提交审核
                if (+this.pjnotice.pjnoticetype === 2 && this.noticeAuditStatus === 2) {
                  this.$message.warning("公告已修改，原审核结果已作废，需重新提交审核！");
                }
              }
              
          } else {
            this.$message.error("保存失败");
          }
          this.btnLoading = false;
          this.loading = false;
        })
        .catch(() => { });
    },
    async getPicrList() {
      //获取接口
      let data = await request({
        url: "/xmgl/pjnotice/getPicrList",
        method: "get",
        params: { cosid: this.$store.getters.loginUser.cosid },
      });

      this.picrList = data;
    },
    close() {
      console.log("this.$route.name", this.$route.name);

      this.$store.commit("close_tab", {
        routeName: this.$route.name,
        vm: this,
        newRouteName: "pjnoticeIndex",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/filelist";

.main {

  .from_input .el-input,
  .el-input .el-input__inner,
  .el-select {
    width: 200px;
  }

  .content .el-textarea__inner,
  .el-textarea,
  .el-input {
    width: 690px;
  }

  .file {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 50%;

    .uploadbtn {
      display: flex;

      span {
        padding-left: 10px;
        color: red;
      }
    }
  }
}
</style>

